import React from 'react';

import {
    Button,
    Check,
    Grid,
    GridColumn,
    Modal,
    ModalCloser,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalProvider,
    ModalTrigger,
    Select,
    TextArea,
} from './../../components';

const QuestionModal = (): React.ReactNode => (
    <ModalProvider defaultIsOpen={true}>
        <ModalTrigger>
            <Button
                text="Open modal"
            />
        </ModalTrigger>
        <Modal size="small">
            <ModalHeader>
                <h4>Edit question</h4>
            </ModalHeader>
            <ModalContent>
                <div className="text">
                    <Select
                        id="select-category"
                        label="Category"
                        name="select"
                        defaultValue='1'
                        options={[
                            {
                                label: 'Engagement',
                                value: '1',
                            },
                            {
                                label: 'Leadership',
                                value: '2',
                            },
                            {
                                label: 'Mission and values',
                                value: '3',
                            },
                            {
                                label: 'Internal communication',
                                value: '4',
                            },
                        ]}
                        type={undefined}
                    />
                    <TextArea
                        id="text-et"
                        label="Question EST"
                        name="text"
                        defaultValue="Kas sa saad aru firma väärtusest?"
                    />
                    <TextArea
                        id="text-en"
                        label="Question ENG"
                        name="text"
                        defaultValue="Are you aware of the companys value proposition?"
                    />
                    <TextArea
                        id="text-ru"
                        label="Question RU"
                        name="text"
                        defaultValue="Знаете ли вы о ценностном предложении компании?"
                    />
                    <Check
                        id="check-1"
                        label="Disable this question"
                        name="check"
                        value="1"
                    />
                </div>
            </ModalContent>
            <ModalFooter>
                <Grid wrap={['xs']} justify={['between-xs']}>
                    <GridColumn width={['xs-12', 'sm-6']}>
                        <ModalCloser>
                            <Button block={true} color="white" text="Cancel" />
                        </ModalCloser>
                    </GridColumn>
                    <GridColumn width={['xs-12', 'sm-6']}>
                        <ModalCloser>
                            <Button block={true} text="Save" />
                        </ModalCloser>
                    </GridColumn>
                </Grid>
            </ModalFooter>
        </Modal>
    </ModalProvider>
);

export default QuestionModal;
